// extracted by mini-css-extract-plugin
export default {"authLink":"reactLink__authLink--pNpAI"};